<template>
    <div></div>
</template>
<script>
import { getTaskApi } from '@/api/entranceTask';

export default {
    props:{
        id: {
            require:true,
            default:''
        }
    },
    methods: {
        async entranceTask() {
            const { code, data } = await getTaskApi(this.id);
            if (code !== 0) return;
            const {
                agreementId, agreementDone, examId, examDone, examinationFlag, examinationDone,
            } = data;
            if ((agreementId && !agreementDone) || (examId && !examDone) || (examinationFlag && !examinationDone)) {
                this.$router.push({
                path: '/entranceTask',
                query: {
                    id: this.id,
                },
                });
            }
        },
    },
   created() {
    this.entranceTask()
   }
}
</script>